export default __webpack_public_path__ + "static/media/deltaLogo.88049ccf.png";